import axios from "../api";
// Hard-deletes the authenticated User and everything it owns (club,
// evolutions, squads) and cancels any active Stripe subscription. See
// apps/mobile/docs/adr/0002-account-deletion-and-subscription-cancellation.md
export const deleteAccount = async () => {
    await axios.delete("/users/me");
};
export default deleteAccount;
//# sourceMappingURL=deleteAccount.js.map